import { apiClient } from "./apiClient";

export const fetchCompanies = async () => {
  try {
    const response = await apiClient.get("/api/v1/company");
    return response.data?.data?.companies || [];
  } catch (err) {
    console.error("Failed to fetch companies:", err);
    throw err;
  }
};


export const createCompany = async (companyData) => {
  try {
    const response = await apiClient.post("/api/v1/company", {
      companyName: companyData.name,
      industry: companyData.industry,
      companyType: companyData.companyType || companyData.type || "SaaS",
      employeesCount: Number(companyData.employees), 
      revenue: Number(companyData.revenue), 
      location: companyData.location,
      createdBy: 4, 
    });

    return response.data;
  } catch (err) {
    console.error(
      "Failed to create company:",
      err.response?.data || err.message
    );
    throw err.response?.data || err;
  }
};



export const selectDDQ = async (companyId, ddTypeId, createdBy) => {
  try {
    const response = await apiClient.post("/api/v1/ddq-selection/select", {
      companyId,
      ddTypeId,
      createdBy,
    });
    console.log("Select DDQ response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in selectDDQ:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchDocumentsByCompanyId = async (companyId) => {
  try {
    const response = await apiClient.get(`/api/v1/palantir/documents/company/${companyId}`);
    return response.data?.data || [];
  } catch (err) {
    console.error("Failed to fetch documents by company ID:", err);
    throw err;
  }
};